import { useState, useEffect } from "react";

function WizInput({
  label,
  isRow,
  forId,
  required,
  labelWidth,
  width,
  children,
  punctuate
}) {
  // handle small screens with react inline styles
  const mediaMatch = window.matchMedia("(min-width: 550px");
  const [matches, setMatches] = useState(mediaMatch.matches);
  const direction = isRow ? "row" : "column";

  useEffect(() => {
    const handler = (e) => setMatches(e.matches);
    mediaMatch.addEventListener("change", handler);
    return () => mediaMatch.removeEventListener("change", handler);
  }, [matches]);

  const Styles = {
    container: (isRowBased) => ({
      display: "flex",
      flexDirection: direction,
      marginTop: "8px",
      width: isRowBased ? width : "100%",
      position: "relative",
    }),
    labelContainer: {
      width: labelWidth,
      display: "flex",
      flexDirection: "column",
      paddingRight: "1rem",
      marginBottom: 3,
      justifyContent: "center",
    },
    label: {
      fontSize: ".8rem",
      fontWeight: 600,
    },
    children: (isRowBased) => ({
      display: "flex",
      flexDirection: "row",
    }),
  };

  return (
    <div style={Styles.container(matches)}>
      <div style={Styles.labelContainer}>
        <label
          htmlFor={forId}
          style={Styles.label}
          className={`${required ? "required-field-before" : ""}`}
        >
          {label}{punctuate}{" "}
        </label>
      </div>
      <div style={Styles.children(matches)}>{children}</div>
    </div>
  );
}
// style={{alignSelf: 'right'}}
export default WizInput;
